import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService implements HttpInterceptor {

  constructor( private router: Router ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token = this.getToken();
    const protectedAPI = req.url.startsWith('backoffice/');
    if ( protectedAPI && token ) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    }
    if (protectedAPI && !token) {
      this.router.navigate(['/backoffice']);
    }

    return next.handle(req);
  }

  getToken() {
    return (document.cookie.split(';').find(x => x.includes('aldefendoBackoffice')) || '=').split('=')[1];
  }
}
